<template>
    <div class="max-w-site mx-auto">
        <div class="flex flex-col mt-16">
            <div class="mx-auto text-3xl font-bold">
                {{ $t('notFound.title') }}
            </div>
            <router-link
                class="btn border-0 font-black text-secondary mx-auto mt-8"
                tag="button"
                to="/"
            >
                <div class="icon">
                    <chevronLeft />
                </div>
                {{ $t('notFound.back.home') }}
            </router-link>
        </div>
    </div>
</template>

<script>
import chevronLeft from '@/assets/svg/chevron_left.svg';

export default {
    components: { chevronLeft }
};
</script>
